import { Pipe, PipeTransform } from '@angular/core';

import { IAttribute } from '../types';

const radix = 10;
const maxDateStringLength = 70;
const maxDateNumberLength = 16;
const yearAddition = 2000;
const allZerosRegex = /^(0{1,5}|0{7}|0{9,})$/;

@Pipe({
    name: 'mcAttributeDateFilter'
})
export class AttributeDatePipe implements PipeTransform {
    // datePipe for correction of wrong display
    transform(attribute: IAttribute, args: { minShortYear: number }): string | number {
        if (this.hasDateProperties(attribute) && !allZerosRegex.test(attribute.value.toString())) {
            const Numb2 = 2; const Numb4 = 4; const Numb0 = 0; const Numb6 = 6; const Numb8 = 8; const Numb10 = 10;
            if ((typeof attribute.value === 'string' && !attribute.value.includes('/'))
                || (typeof attribute.value === 'number' && attribute.value < 20450000)) {
                const cleanDate = attribute.value.toString();
                if (cleanDate.includes('-')) {
                    return cleanDate;
                }
                let year = parseInt(cleanDate.length > 6 ? cleanDate.substring(Numb0, Numb4) : cleanDate.substring(Numb0, Numb2), radix);
                if (args && args.minShortYear !== undefined && year < args.minShortYear) {
                    year = year + yearAddition;
                }
                let month = parseInt(cleanDate.length > 6 ? cleanDate.substring(Numb4, Numb6) : cleanDate.substring(Numb2, Numb4), radix);
                if (month === 0) {
                    month = 1;
                }
                let dates = parseInt(cleanDate.length > 6 ? cleanDate.substring(Numb6, Numb8) : cleanDate.substring(Numb4, Numb6), radix);
                if (dates === 0) {
                    dates = 1;
                }
                const tempdate = new Date(year, month - 1, dates); // the month is 0-indexed

                return !isNaN(tempdate.valueOf()) ? `${year === 0 ? '0000' : tempdate.getFullYear()}-${month}-${dates}` : attribute.value;
            }
            const date = new Date(attribute.value);
            const y = date.getFullYear();
            const m = date.getMonth() + 1;
            const d = date.getUTCDate();
            const p = (m < Numb10) ? `0${m}` : m;
            const q = (d < Numb10) ? `0${d}` : d;
            return [y, p, q].join('-');
        }
        return attribute.value;
    }

    private hasDateProperties(attribute: IAttribute) {
        let retVal = false;
        if (attribute.value !== null && this.dateLengthCondition(attribute) && (this.dateTypeCondition(attribute) || this.dateNameCondition(attribute))) {
            retVal = true;
        }
        return retVal;
    }

    private dateLengthCondition(attribute: IAttribute) {
        let retVal = false;
        if (typeof attribute.value === 'string') {
            retVal = attribute.value.trim().length <= maxDateStringLength;
        } else {
            retVal = attribute.value.toString().length <= maxDateNumberLength;
        }
        return retVal;
    }
    private dateTypeCondition(attribute: IAttribute) { return attribute.type === 'date'; }
    private dateNameCondition(attribute: IAttribute) {
        return (attribute.displayName !== null && attribute.displayName.toLowerCase().includes('date'))
            || (attribute.columnName !== null && attribute.columnName.toLowerCase().includes('date'));
    }
}
